import { render, staticRenderFns } from "./FeedbackNameList.vue?vue&type=template&id=75d7a5f1&"
import script from "./FeedbackNameList.vue?vue&type=script&lang=js&"
export * from "./FeedbackNameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports